<template>
  <b-card class="mb-0">
    <h2 class="text-center">
      Visa
    </h2>
    <div class="d-flex justify-content-between">
      <div class="d-flex flex-column align-items-center">
        <h4>
          Paid by visa
        </h4>
        <div class="d-flex align-items-center">
          <b-badge
            pill
            :variant="`${!paidByVisa ? 'danger' : 'success'}`"
            style="padding:8px 14px"
          >
            {{ !paidByVisa ? "No" : "Yes" }}
          </b-badge>
          <span v-if="shouldShowPaymentFlow()" class="mx-2">
            →
          </span>
          <b-badge
            v-if="shouldShowPaymentFlow()"
            pill
            :variant="getPaymentFlowVariant()"
            style="padding:8px 14px"
          >
            {{ getPaymentFlowDisplay() }}
          </b-badge>
        </div>
      </div>
      <div
        v-if="tripBillDetails && tripBillDetails.payment.state"
        class="d-flex flex-column align-items-center"
      >
        <h4>
          Payment Status
        </h4>
        <b-badge
          pill
          :variant="visaStatusBadgeVariant(tripBillDetails.payment.state)"
          style="padding:8px 14px"
        >
          {{ snakeCaseToCamelCase(tripBillDetails.payment.state) }}
        </b-badge>
      </div>
    </div>
    <div v-if="visaFailureReason" class="mt-2">
      <small class="text-danger">
        Failure Reason: {{ visaFailureReason }}
      </small>
    </div>
  </b-card>
</template>

<script>
import { BCard, BBadge } from "bootstrap-vue";
import { computed, inject } from "@vue/composition-api";
import snakeCaseToCamelCase from "@/utils/snake-case-to-camcel-caase";

const PENDING = "PENDING";
// const FAILED = 'FAILED'
const SUCCEEDED = "SUCCEEDED";

export default {
  components: {
    BCard,
    BBadge,
  },
  setup(_, ctx) {
    const trip = inject("trip");
    const tripBillDetails = computed(
      () => ctx.root.$store.getters["trips/getTripBillDetails"]
    );

    const shouldShowPaymentFlow = () => {
      const paymentHistory = trip.value.payment_method_history;
      // If no payment history or empty array, don't show flow
      if (!paymentHistory || paymentHistory.length === 0) {
        return false;
      }

      const firstEntry = paymentHistory[0];
      const lastEntry = paymentHistory[paymentHistory.length - 1];

      return (
        firstEntry.current_payment_method_id && !lastEntry.new_payment_method_id
      );
    };

    const visaFailureReason = computed(
      () => tripBillDetails.value?.payment?.meta?.error
    );
    const paidByVisa = computed(() => {
      // If shouldShowPaymentFlow is true, always return true (Yes)
      if (shouldShowPaymentFlow()) {
        return true;
      }
      // Otherwise use current behavior
      return trip.value.payment_method_id
        ? !!trip.value.payment_method_id
        : tripBillDetails.value?.meta?.details?.paid_by_visa;
    });

    const visaStatusBadgeVariant = (state) => {
      if (state === PENDING) return "warning";
      if (state === SUCCEEDED) return "success";
      return "danger";
    };

    const getPaymentFlowDisplay = () => "Cash";

    const getPaymentFlowVariant = () => "secondary";

    return {
      snakeCaseToCamelCase,
      visaStatusBadgeVariant,
      tripBillDetails,
      paidByVisa,
      shouldShowPaymentFlow,
      getPaymentFlowDisplay,
      getPaymentFlowVariant,
      visaFailureReason,
    };
  },
};
</script>

<style></style>
